export const initialFilters = {
    input_text: '',
    grade: '',
    subject: '',
    publication_language: '',
    username: '',
    role: '',
    limit: 24,
    offset: 0,
    is_for_expertize: true
}

export const initialSearchFilters = {
    publication_language: '',
    input_text: '',
    grade: [],
    subject: [],
    username: '',
    role: '',
    limit: 24,
    offset: 0,
}

export const gradeOptions = [
    {
        name: {
            'RU': '1-й класс',
            'KZ': '1-сынып',
        },
        value: 1,
        checked: false,
    },
    {
        name: {
            'RU': '2-й класс',
            'KZ': '2-сынып',
        },
        value: 2,
        checked: false,
    },
    {
        name: {
            'RU': '3-й класс',
            'KZ': '3-сынып',
        },
        value: 3,
        checked: false,
    },
    {
        name: {
            'RU': '4-й класс',
            'KZ': '4-сынып',
        },
        value: 4,
        checked: false,
    },
    {
        name: {
            'RU': '5-й класс',
            'KZ': '5-сынып',
        },
        value: 5,
        checked: false,
    },
    {
        name: {
            'RU': '6-й класс',
            'KZ': '6-сынып',
        },
        value: 6,
        checked: false,
    },
    {
        name: {
            'RU': '7-й класс',
            'KZ': '7-сынып',
        },
        value: 7,
        checked: false,
    },
    {
        name: {
            'RU': '8-й класс',
            'KZ': '8-сынып',
        },
        value: 8,
        checked: false,
    },
    {
        name: {
            'RU': '9-й класс',
            'KZ': '9-сынып',
        },
        value: 9,
        checked: false,
    },
    {
        name: {
            'RU': '10-й класс',
            'KZ': '10-сынып',
        },
        value: 10,
        checked: false,
    },
    {
        name: {
            'RU': '11-й класс',
            'KZ': '11-сынып',
        },
        value: 11,
        checked: false,
    },
]

export const languageOptions = [
    {
        name: {
            'RU': 'Қазақша',
            'KZ': 'Қазақша',
        },
        value: 'KZ'
    },
    {
        name: {
            'RU': 'Русский',
            'KZ': 'Русский',
        },
        value: 'RU'
    },
    {
        name: {
            'RU': 'Уйғур тили',
            'KZ': 'Уйғур тили',
        },
        value: 'UG'
    },
    {
        name: {
            'RU': 'English',
            'KZ': 'English',
        },
        value: 'EN'
    },
]

export const publisherOptions = [
    {
        name: {
            'RU': 'все',
            'KZ': 'Барлық',
        },
        value: ''
    },
    {
        name: {
            'RU': 'Мектеп',
            'KZ': 'Мектеп',
        },
        value: 'Мектеп'
    },
]

export const packageOptions = [
    {
        name: {
            'RU': 'все',
            'KZ': 'Барлық',
        },
        value: ''
    },
]

export const subjectsOptionsRU = [
    {
        name: {
            'RU': 'все',
            'KZ': 'Барлық',
        },
        value: '',
        checked: false,
    },
    {
        name: {
            'RU': 'Английский язык',
            'KZ': 'Ағылшын тілі',
        },
        value: 'Английский язык',
        checked: false,
    },
    {
        name: {
            'RU': 'Начальная военная и технологическая подготовка',
            'KZ': 'Алғашқы әскери және технологиялық дайындық',
        },
        value: 'Начальная военная и технологическая подготовка',
        checked: false,
    },
    {
        name: {
            'RU': 'Родной язык',
            'KZ': 'Ана тілі',
        },
        value: 'Родной язык',
        checked: false,
    },
    {
        name: {
            'RU': 'Литературное чтение',
            'KZ': 'Әдебиеттік оқу',
        },
        value: 'Литературное чтение',
        checked: false,
    },
    {
        name: {
            'RU': 'Изобразительное искусство',
            'KZ': 'Бейнелеу өнері',
        },
        value: 'Изобразительное искусство',
        checked: false,
    },
    {
        name: {
            'RU': 'Биология',
            'KZ': 'Биология',
        },
        value: 'Биология',
        checked: false,
    },
    {
        name: {
            'RU': 'География',
            'KZ': 'География',
        },
        value: 'География',
        checked: false,
    },
    {
        name: {
            'RU': 'Графика и проектирование',
            'KZ': 'Графика және жобалау',
        },
        value: 'Графика и проектирование',
        checked: false,
    },
    {
        name: {
            'RU': 'Физическая культура',
            'KZ': 'Дене шынықтыру',
        },
        value: 'Физическая культура',
        checked: false,
    },
    {
        name: {
            'RU': 'Познание мира',
            'KZ': 'Дүниетану',
        },
        value: 'Познание мира',
        checked: false,
    },
    {
        name: {
            'RU': 'Трудовое обучение',
            'KZ': 'Еңбекке баулу',
        },
        value: 'Трудовое обучение',
        checked: false,
    },
    {
        name: {
            'RU': 'Информатика',
            'KZ': 'Информатика',
        },
        value: 'Информатика',
        checked: false,
    },
    {
        name: {
            'RU': 'Казахская литература',
            'KZ': 'Қазақ әдебиеті',
        },
        value: 'Казахская литература',
        checked: false,
    },
    {
        name: {
            'RU': 'Казахский язык',
            'KZ': 'Қазақ тілі',
        },
        value: 'Казахский язык',
        checked: false,
    },
    {
        name: {
            'RU': 'Основы права',
            'KZ': 'Құқық негіздері',
        },
        value: 'Основы права',
        checked: false,
    },
    {
        name: {
            'RU': 'Математика',
            'KZ': 'Математика',
        },
        value: 'Математика',
        checked: false,
    },
    {
        name: {
            'RU': 'Музыка',
            'KZ': 'Музыка',
        },
        value: 'Музыка',
        checked: false,
    },
    {
        name: {
            'RU': 'Русский язык и Русская литература',
            'KZ': 'Орыс тілі мен әдебиеті',
        },
        value: 'Русский язык и Русская литература',
        checked: false,
    },
    {
        name: {
            'RU': 'История',
            'KZ': 'Тарихы',
        },
        value: 'История',
        checked: false,
    },
    {
        name: {
            'RU': 'Физика',
            'KZ': 'Физика',
        },
        value: 'Физика',
        checked: false,
    },
    {
        name: {
            'RU': 'Химия',
            'KZ': 'Химия',
        },
        value: 'Химия',
        checked: false,
    },
    {
        name: {
            'RU': 'Иностранный язык',
            'KZ': 'Шет тілі',
        },
        value: 'Иностранный язык',
        checked: false,
    },
]

export const subjectsOptionsKZ = [
    {
        name: {
            'RU': 'все',
            'KZ': 'Барлық',
        },
        value: '',
        checked: false,
    },
    {
        name: {
            'RU': 'Английский язык',
            'KZ': 'Ағылшын тілі',
        },
        value: 'Ағылшын тілі',
        checked: false,
    },
    {
        name: {
            'RU': 'Начальная военная и технологическая подготовка',
            'KZ': 'Алғашқы әскери және технологиялық дайындық',
        },
        value: 'Алғашқы әскери және технологиялық дайындық',
        checked: false,
    },
    {
        name: {
            'RU': 'Родной язык',
            'KZ': 'Ана тілі',
        },
        value: 'Ана тілі',
        checked: false,
    },
    {
        name: {
            'RU': 'Литературное чтение',
            'KZ': 'Әдебиеттік оқу',
        },
        value: 'Әдебиеттік оқу',
        checked: false,
    },
    {
        name: {
            'RU': 'Изобразительное искусство',
            'KZ': 'Бейнелеу өнері',
        },
        value: 'Бейнелеу өнері',
        checked: false,
    },
    {
        name: {
            'RU': 'Биология',
            'KZ': 'Биология',
        },
        value: 'Биология',
        checked: false,
    },
    {
        name: {
            'RU': 'География',
            'KZ': 'География',
        },
        value: 'География',
        checked: false,
    },
    {
        name: {
            'RU': 'Графика и проектирование',
            'KZ': 'Графика және жобалау',
        },
        value: 'Графика және жобалау',
        checked: false,
    },
    {
        name: {
            'RU': 'Физическая культура',
            'KZ': 'Дене шынықтыру',
        },
        value: 'Дене шынықтыру',
        checked: false,
    },
    {
        name: {
            'RU': 'Познание мира',
            'KZ': 'Дүниетану',
        },
        value: 'Дүниетану',
        checked: false,
    },
    {
        name: {
            'RU': 'Трудовое обучение',
            'KZ': 'Еңбекке баулу',
        },
        value: 'Еңбекке баулу',
        checked: false,
    },
    {
        name: {
            'RU': 'Информатика',
            'KZ': 'Информатика',
        },
        value: 'Информатика',
        checked: false,
    },
    {
        name: {
            'RU': 'Казахская литература',
            'KZ': 'Қазақ әдебиеті',
        },
        value: 'Қазақ әдебиеті',
        checked: false,
    },
    {
        name: {
            'RU': 'Казахский язык',
            'KZ': 'Қазақ тілі',
        },
        value: 'Қазақ тілі',
        checked: false,
    },
    {
        name: {
            'RU': 'Основы права',
            'KZ': 'Құқық негіздері',
        },
        value: 'Құқық негіздері',
        checked: false,
    },
    {
        name: {
            'RU': 'Математика',
            'KZ': 'Математика',
        },
        value: 'Математика',
        checked: false,
    },
    {
        name: {
            'RU': 'Музыка',
            'KZ': 'Музыка',
        },
        value: 'Музыка',
        checked: false,
    },
    {
        name: {
            'RU': 'Русский язык и Русская литература',
            'KZ': 'Орыс тілі мен әдебиеті',
        },
        value: 'Орыс тілі мен әдебиеті',
        checked: false,
    },
    {
        name: {
            'RU': 'История',
            'KZ': 'Тарихы',
        },
        value: 'Тарихы',
        checked: false,
    },
    {
        name: {
            'RU': 'Физика',
            'KZ': 'Физика',
        },
        value: 'Физика',
        checked: false,
    },
    {
        name: {
            'RU': 'Химия',
            'KZ': 'Химия',
        },
        value: 'Химия',
        checked: false,
    },
    {
        name: {
            'RU': 'Иностранный язык',
            'KZ': 'Шет тілі',
        },
        value: 'Шет тілі',
        checked: false,
    },
]

export const subjectsOptions = [
    {
        name: {
            'RU': 'Английский язык',
            'KZ': 'Ағылшын тілі',
            'EN': 'English',
            'UG': 'Инглиз тили'
        },
        value: 'English',
        checked: false,
    },
    {
        name: {
            'RU': 'Начальная военная и технологическая подготовка',
            'KZ': 'Алғашқы әскери және технологиялық дайындық',
            'EN': 'Basic military and technological training',
            'UG': 'Башланғуч һәрбий вә технологиялик тәйярлиқ'
        },
        value: 'Basic military and technological training',
        checked: false,
    },
    {
        name: {
            'RU': 'Родной язык',
            'KZ': 'Ана тілі',
            'EN': 'Native language',
            'UG': 'Ана тили'
        },
        value: 'Native language',
        checked: false,
    },
    {
        name: {
            'RU': 'Литературное чтение',
            'KZ': 'Әдебиеттік оқу',
            'EN': 'Literary reading',
            'UG': 'Әдәбий оқуш'
        },
        value: 'Literature reading',
        checked: false,
    },
    {
        name: {
            'RU': 'Изобразительное искусство',
            'KZ': 'Бейнелеу өнері',
            'EN': 'Art',
            'UG': 'Тәсвирий сәнъәт'
        },
        value: 'Art',
        checked: false,
    },
    {
        name: {
            'RU': 'Биология',
            'KZ': 'Биология',
            'EN': 'Biology',
            'UG': 'Биология'
        },
        value: 'Biology',
        checked: false,
    },
    {
        name: {
            'RU': 'География',
            'KZ': 'География',
            'EN': 'Geography',
            'UG': 'География'
        },
        value: 'Geography',
        checked: false,
    },
    {
        name: {
            'RU': 'Графика и проектирование',
            'KZ': 'Графика және жобалау',
            'EN': 'Graphics and design',
            'UG': 'Графика вә лайиһәләш'
        },
        value: 'Graphics and design',
        checked: false,
    },
    {
        name: {
            'RU': 'Физическая культура',
            'KZ': 'Дене шынықтыру',
            'EN': 'Physical education',
            'UG': 'Тән тәрбийә'
        },
        value: 'Physical education',
        checked: false,
    },
    {
        name: {
            'RU': 'Познание мира',
            'KZ': 'Дүниетану',
            'EN': 'Getting to know the world',
            'UG': 'Дуния тонуш'
        },
        value: 'Getting to know the world',
        checked: false,
    },
    {
        name: {
            'RU': 'Трудовое обучение',
            'KZ': 'Еңбекке баулу',
            'EN': 'Manual training',
            'UG': 'Әмгәккә үгитиш'
        },
        value: 'Manual training',
        checked: false,
    },
    {
        name: {
            'RU': 'Информатика',
            'KZ': 'Информатика',
            'EN': 'Informatics',
            'UG': 'Информатика'
        },
        value: 'Informatics',
        checked: false,
    },
    {
        name: {
            'RU': 'Казахская литература',
            'KZ': 'Қазақ әдебиеті',
            'EN': 'Kazakh literature',
            'UG': 'Қазақ әдәбияти'
        },
        value: 'Kazakh literature',
        checked: false,
    },
    {
        name: {
            'RU': 'Казахский язык',
            'KZ': 'Қазақ тілі',
            'EN': 'Kazakh',
            'UG': 'Қазақ тили'
        },
        value: 'Kazakh',
        checked: false,
    },
    {
        name: {
            'RU': 'Основы права',
            'KZ': 'Құқық негіздері',
            'EN': 'Fundamentals of Law',
            'UG': 'Һоқуқ асаслири'
        },
        value: 'Fundamentals of Law',
        checked: false,
    },
    {
        name: {
            'RU': 'Математика',
            'KZ': 'Математика',
            'EN': 'Mathematics',
            'UG': 'Математика'
        },
        value: 'Mathematics',
        checked: false,
    },
    {
        name: {
            'RU': 'Музыка',
            'KZ': 'Музыка',
            'EN': 'Music',
            'UG': 'Музыка'
        },
        value: 'Music',
        checked: false,
    },
    {
        name: {
            'RU': 'Русский язык и Русская литература',
            'KZ': 'Орыс тілі мен әдебиеті',
            'EN': 'Russian language and literature',
            'UG': 'Рус тили вә Рус әдәбияти'
        },
        value: 'Russian language and literature',
        checked: false,
    },
    {
        name: {
            'RU': 'История',
            'KZ': 'Тарихы',
            'EN': 'History',
            'UG': 'Тарих'
        },
        value: 'History',
        checked: false,
    },
    {
        name: {
            'RU': 'Физика',
            'KZ': 'Физика',
            'EN': 'Physics',
            'UG': 'Физика'
        },
        value: 'Physics',
        checked: false,
    },
    {
        name: {
            'RU': 'Химия',
            'KZ': 'Химия',
            'EN': 'Chemistry',
            'UG': 'Химия'
        },
        value: 'Chemistry',
        checked: false,
    },
    {
        name: {
            'RU': 'Иностранный язык',
            'KZ': 'Шет тілі',
            'EN': 'Foreign language',
            'UG': 'Чәтәл тили'
        },
        value: 'Foreign language',
        checked: false,
    },
    {
        name: {
            'RU': 'Уйгурский язык',
            'KZ': 'Ұйғыр',
            'EN': 'Uigur',
            'UG': 'Ұйғыр тілі'
        },
        value: 'Uigur',
        checked: false,
    },
]
